import React, { useEffect, useRef, useState } from 'react'
import AppPopover from '../../../UIComponents/ModalShell/AppPopover'
import { useDispatch, useSelector } from 'react-redux'
import Hotkeys from 'react-hot-keys'

import Button from '../../../UIControls/Button'
import { hideFloatPopup, showFloatPopup } from '../../../../redux/actions'
import { execShortcutFn } from '../../../UIComponents/ShortcutCheatSheet/HelperFunctions'
import { updateAssistantReasoningEffort } from '../../../../utils/backends/Assistants/assistantsFirestore'
import AssistantReasoningEffortModal from '../../../UIComponents/FloatModals/AssistantReasoningEffortModal/AssistantReasoningEffortModal'
import { translate } from '../../../../i18n/TranslationService'
import {
    getAssistantReasoningEffortLabelKey,
    normalizeAssistantReasoningEffort,
} from '../../../../functions/Assistant/selectableAssistantReasoningEfforts'

export default function ReasoningEffortWrapper({ disabled, projectId, assistant }) {
    const dispatch = useDispatch()
    const blockShortcuts = useSelector(state => state.blockShortcuts)
    const mobile = useSelector(state => state.smallScreenNavigation)
    const [isOpen, setIsOpen] = useState(false)
    const isOpenRef = useRef(false)
    const reasoningEffort = normalizeAssistantReasoningEffort(
        assistant.reasoningEffort,
        assistant.model || 'MODEL_GPT6_SOL'
    )

    const openModal = () => {
        setIsOpen(true)
        dispatch(showFloatPopup())
    }

    const closeModal = () => {
        setIsOpen(false)
        dispatch(hideFloatPopup())
    }

    useEffect(() => {
        isOpenRef.current = isOpen
    }, [isOpen])

    useEffect(() => {
        return () => {
            if (isOpenRef.current) dispatch(hideFloatPopup())
        }
    }, [])

    return (
        <AppPopover
            content={
                <AssistantReasoningEffortModal
                    model={assistant.model}
                    closeModal={closeModal}
                    reasoningEffort={reasoningEffort}
                    updateReasoningEffort={value => updateAssistantReasoningEffort(projectId, assistant, value)}
                />
            }
            align={'start'}
            position={['bottom']}
            onClickOutside={closeModal}
            isOpen={isOpen}
            contentLocation={mobile ? null : undefined}
        >
            <Hotkeys
                keyName={'alt+E'}
                disabled={blockShortcuts || isOpen || disabled}
                onKeyDown={(shortcut, event) => execShortcutFn(this.btnRef, openModal, event)}
                filter={event => true}
            >
                <Button
                    ref={ref => (this.btnRef = ref)}
                    type={'ghost'}
                    icon={'edit-2'}
                    onPress={openModal}
                    disabled={isOpen || disabled}
                    shortcutText={'E'}
                    title={translate(getAssistantReasoningEffortLabelKey(reasoningEffort))}
                />
            </Hotkeys>
        </AppPopover>
    )
}
